export default {
  SET_CURRENT_USER (state, currentUserData) {
    state.currentUser = currentUserData
  },
  SET_CURRENT_GROUPS (state, currentGroups) {
    state.currentGroups = currentGroups
  },
  REMOVE_CURRENT_USER (state) {
    state.currentUser = {}
  }
}
